import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { ScenarioRecommendation } from 'src/types/domain';
import { RecommendationCard } from 'src/containers';
import * as S from './styles';
import { msgs } from './messages';

interface RecommendationListProps {
  scenarioRecommendations: ScenarioRecommendation[];
  sectionTitle?: string | null;
}

export const RecommendationList: FC<RecommendationListProps> = ({
  scenarioRecommendations,
  sectionTitle,
}) => {
  const intl = useIntl();

  if (!scenarioRecommendations.length) return null;

  return (
    <S.Wrapper>
      <S.Label>{sectionTitle ?? intl.formatMessage(msgs.recommendationLabel)}</S.Label>
      <S.CardsWrapper>
        {scenarioRecommendations.map(
          ({
            iconUrl,
            influencerName,
            isInfluencer,
            numberOfLearnables,
            scenarioId,
            title,
            titleSlug,
            topicId,
            topicNameSlug,
          }) => {
            return (
              <RecommendationCard
                key={scenarioId}
                scenarioId={scenarioId}
                title={title}
                titleSlug={titleSlug}
                iconUrl={iconUrl}
                numberOfLearnables={numberOfLearnables}
                isInfluencer={isInfluencer}
                influencerName={influencerName}
                topicId={topicId}
                topicTitleSlug={topicNameSlug}
              />
            );
          },
        )}
      </S.CardsWrapper>
    </S.Wrapper>
  );
};
